module.exports = __webpack_public_path__ + "static/media/location.301028d4.svg";